import React, { useEffect, useState } from 'react'
import { CButton, Loading } from '../../Components';
import { useNavigate } from 'react-router-dom';
import AdminNavbar from '../Navbar/AdminNavbar';
import { Button, Form, InputGroup } from 'react-bootstrap';
import MakePagination from '../../Components/MakePagination';
import { urlPrefix } from '../../Helpers/Common';
import { deletePublisher, getAdminPublishers } from '../Services/Publisher';
import { useDebounce } from '../../../CustomHooks/DebounceHook';
import ConfirmationModal from '../Books/Components/ConfirmationModal';
import { toast } from 'react-toastify';

const ListPublishers = () => {
    const navigate = useNavigate()
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [publishers, setPublishers] = useState([]);
    const [totalPublishers, setTotalPublishers] = useState(0);
    const [pagination, setPagination] = useState({ limit: 10, start_from: 0, search: null, order_by: [{ column: 'publishers.id', order: 'desc' }] });
    const debouncedSearch = useDebounce(search,500);
    const [confirmationModal,setConfirmationModal] = useState({show:false, data: null, acceptFx: null, rejectFx: null,message:null});

    const selectFilter = (filter, data) => {
        if (filter === "order") {
            setPagination({ ...pagination, order_by: [data] })
        }
        else if (filter === "pagination") {
            setPagination({ ...pagination, start_from: data })
        }
        else if (filter === "search") {
            setPagination({ ...pagination, start_from: 0, search: data && data.length ? data.trim() : null })
        }
    }

    const getInitialPageData = async () => {
        setLoading(true)
        const result = await getAdminPublishers({ ...pagination, total_count_of: "publishers.id" });
        setPublishers(result.data.publishers)
        setTotalPublishers(result.data.totalPublisherRecords)
        setLoading(false)
    }

    // delete publisher
    const deletePublisherClick = async (data) => {
        const { id } = data;
        setLoading(true)
        const result = await deletePublisher({id})
        if (result.success) {
            toast.success(result.message)
            getInitialPageData()
        } else {
            toast.error(result?.error?.message)
        }
        setConfirmationModal({show:false, data: null, acceptFx: null, rejectFx: null,message:null})
        setLoading(false)
    }

    useEffect(() => {
        getInitialPageData()
    }, [pagination])

    useEffect(()=>{ 
        selectFilter("search",search)
    },[debouncedSearch])

    return (
        <div className="admin-panel-main">
            <div className="panel-row">
                <div className="left">
                    <AdminNavbar></AdminNavbar>
                </div>
                <div className="right">
                    <div className="panel-title-top all-book">
                        <div className="top-left">
                            <h3 className="heading-h3">Publishers list</h3>
                        </div>
                        <div className="top-right admin-filter">
                            <div className="right-side">
                                <CButton fxToRun={() => { navigate(urlPrefix() + "/admin/publishers/insert") }} label="Add Publisher" custClassName="login-button t-btn"></CButton>
                            </div>
                        </div>
                    </div>

                    <div className="dash-filter filter">
                        <div className="left-fil" />
                        <div className="search">
                            <InputGroup className="admin-search-input" onChange={(e) => setSearch(e.target.value)} >
                                <Form.Control placeholder="Search Publisher name" value={search || ""} />
                            </InputGroup>
                        </div>
                    </div>

                    <div className="admin-panel-data">
                        <div className="top-title all-plans">
                            <div className="order-no">
                                <p className="top-t">Name</p>
                            </div>
                            <div className="title">
                                <p className="top-t">Description</p>
                            </div>
                            <div className="e-edit-delete">
                                <p className="top-t">Actions</p>
                            </div>
                        </div>
                        <div className="book-list">
                            {
                                publishers && publishers.length ?
                                    publishers.map((publisher) => <div className="book-row all-plans" key={publisher.publisher_id}>
                                        <div className="order-no-value">
                                            <p className="top-value">{publisher.name}</p>
                                        </div>
                                        <div className="title-value">
                                            <p className="top-value">{publisher.description}</p>
                                        </div>
                                        <div className="e-edit-delete-value">
                                            <a className="edit-action" onClick={() => navigate(urlPrefix() + `/admin/publishers/edit/${publisher.publisher_id}`)}><img src={urlPrefix() + "/assets/image/edit-green.png"} alt='book-image' /></a>
                                            <a className="delete-action" onClick={() => setConfirmationModal({
                                                show:true,
                                                data:{ id: publisher.publisher_id},
                                                acceptFx:deletePublisherClick,
                                                message:`Are you sure, you want to delete publisher ?`,
                                                rejectFx:()=>{setConfirmationModal({ show:false, data: null, acceptFx: null, rejectFx: null, message:null})}
                                            })}><img src={urlPrefix() + "/assets/image/trash.svg"} alt='book-image' /></a>
                                        </div>
                                    </div>) :
                                    <div className='no-data'>
                                        No Publishers found.
                                    </div>
                            }

                            {
                                publishers && publishers.length ?
                                    <div className="books-pagination">
                                        <MakePagination totalRecords={totalPublishers} limiter={10} selectFilter={selectFilter}></MakePagination>
                                    </div> : null
                            }

                        </div>
                    </div>
                </div>
            </div>
            {
                loading ? <Loading /> : null
            }
            <ConfirmationModal confirmationModal={confirmationModal}/>
        </div>
    )
}

export default ListPublishers
